export default __webpack_public_path__ + "static/media/defaultJobIcon.d9d47cc0.svg";